// Generic
export const SET_LOADER = "SET_LOADER"
export const SET_TITLE = "SET_TITLE"
export const SET_USER = "SET_USER"
export const SET_TOKEN = "SET_TOKEN"
export const SET_LOGOUT = "SET_LOGOUT"
export const SET_STAFF_DIALOG = "SET_STAFF_DIALOG"
export const SET_BREADCRUMB = "SET_BREADCRUMB"
export const UPDATE_CRUMB = "UPDATE_CRUMB"
export const SET_UPDATER = "SET_UPDATER"
export const SET_LOGS_FILTERS = "SET_LOGS_FILTERS"
export const SET_ORDERS = "SET_ORDERS"
export const SET_TEMPORARY_ORDERS = "SET_TEMPORARY_ORDERS"
export const SET_ORDERS_TO_AGGREGATE = "SET_ORDERS_TO_AGGREGATE"
export const SET_ORDER_FILTERS = "SET_ORDER_FILTERS"
export const SET_LANGUAGE = "SET_LANGUAGE"
export const SET_PAGE_SIZE = "SET_PAGE_SIZE"
export const SET_ORDERS_TAB = "SET_ORDERS_TAB"
export const SET_NOTIFICATION_TOKEN = "SET_NOTIFICATION_TOKEN"
export const SET_FILTERS = "SET_FILTERS"
export const SET_OPERATION_LINKS_VIEW_MODE = "SET_OPERATION_LINKS_VIEW_MODE"
export const SET_OPERATION_LINKS_COLLAPSED_GROUPS =
	"SET_OPERATION_LINKS_COLLAPSED_GROUPS"
export const SET_ROUTES_TABLE_WIDTH = "SET_ROUTES_TABLE_WIDTH"
export const SET_ROUTES_PAGE_SIZE = "SET_ROUTES_PAGE_SIZE"
export const SET_ORDERS_TABLE_WIDTH = "SET_ORDERS_TABLE_WIDTH"
export const SET_ORDERS_STATUS_FILTER = "SET_ORDERS_STATUS_FILTER"
export const SET_ORDER_GLOBAL_INFO = "SET_ORDER_GLOBAL_INFO"
export const SET_SIDEBAR_OPEN_GROUPS = "SET_SIDEBAR_OPEN_GROUPS"
